import { formatDate, formatMoney, getAgentFullName } from "../../../shared/utils"
import links from "../links"
import LabeledContainer from "./LabeledContainer"
import StyledLink from "./StyledLink"
import LabelValue from "./LabelValue"

// helpers
export default function LoanDetails({ principal, annual_rate, tenure, owing, deposit, agent, created_at, issued_at }) {
   return <LabeledContainer label="Details" className="rounded-lg p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
         <LabelValue label="Principal" value={formatMoney(principal)} />
         <LabelValue label="Rate" value={annual_rate ? `${annual_rate}%` : '–' } />
         <LabelValue label="Tenure" value={`${tenure} months`} />
         <LabelValue label="Owing" value={owing ? formatMoney(owing) : '–' } />
         <LabelValue label="Deposit" value={formatMoney(deposit)} />
         { 
            agent && <LabelValue
               label="Agent"
               value={
                  <StyledLink to={links.agent(agent._id)} className="text-sm">
                     {getAgentFullName(agent)}
                  </StyledLink>
               }
            />
         }
         <LabelValue
            label="Date Applied"
            value={formatDate(created_at)}
         />
         {
            issued_at && <LabelValue
               label="Date Issued"
               value={formatDate(issued_at)}
            />
         }
      </div>
   </LabeledContainer>
}